/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

// import createVuexAlong from 'vuex-along'

import api from '@/api'

// 导入设置的常量
import appConst from '@/utils/const.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    manageAccessName: 'tjlx2019123', // 管理账号
    userInfo: {}, // 用户信息
    userStudyProgress: {}, // 用户学习进度
    managePass: false // 是否通过了管理验证
  },
  mutations: {
    // 更新用户信息
    UPDATE_USER_INFO(state, payload) {
      state.userInfo = payload
    },
    // 更新用户姓名
    UPDATE_USER_NAME(state, payload) {
      state.userInfo.nickName = payload
    },
    // 更新用户学习进度
    UPDATE_USER_STUDY_PROGRESS(state, payload) {
      state.userStudyProgress = payload
    },
    // 更新为通过了管理验证
    UPDATE_MANAGE_PASS(state, payload) {
      state.managePass = payload
    }
  },
  // 注册异步方法
  actions: {
    // 获取用户学习进度
    getUserStudyProgress({
      commit
    }) {
      api.videoPlayRecordStudyrecord.r({
        year: appConst.defaultYear
      }).then((res) => {
        // 用户播放总时长，单位秒
        let studyDuration = res.data.data.studyDuration
        // 用户学习时长小时数量
        let studyH = parseInt(studyDuration / 3600) ? parseInt(studyDuration / 3600) + '小时' : ''
        // 用户学习时长分钟数量
        let studyM = parseInt(parseInt(studyDuration % 3600) / 60) ? parseInt(parseInt(studyDuration % 3600) / 60) + '分' : ''
        // 用户学习时长秒数量
        let studyS = parseInt(studyDuration % 60) ? parseInt(studyDuration % 60) + '秒' : ''
        // 用户学习时长文字
        let studyDurationText = studyH + studyM + studyS
        // 用户学习完成视频数量
        let studyNum = res.data.data.studyNum
        // 视频总数量
        let videoNum = res.data.data.videoNum
        // 用户完成视频进度
        let studyProgress = studyNum > 0 ? (((studyNum * 100) % videoNum) ? ((studyNum / videoNum) * 100).toFixed(2) : parseInt((studyNum / videoNum) * 100)) + '%' : 0
        // 将用户学习进度存储在vuex store中
        commit('UPDATE_USER_STUDY_PROGRESS', {
          studyDuration: studyDurationText,
          studyNum: studyNum,
          videoNum: videoNum,
          studyProgress: studyProgress
        })
      })
    }
  }
  // strict: process.env.NODE_ENV !== 'production',
  // plugins: [createVuexAlong({
  //   name: 'manage-vuex-along', // 设置保存的集合名字，避免同站点下的多项目数据冲突
  //   local: {
  //     list: ['userInfo', 'userStudyProgress'],
  //     isFilter: true // 过滤模块 userInfo 和 userStudyProgress 数据， 将其他的存入 localStorage
  //   },
  //   session: {
  //     list: ['managePass'] // 保存 managePass 到 sessionStorage
  //   }
  // })]
})



// WEBPACK FOOTER //
// ./src/store/index.js